export default "__VITE_ASSET__jPmLgru1__"